module.exports = __webpack_public_path__ + "img/approval2.029f43c9.png";